'use strict';

var React = require('react');
require('prop-types');
var ObjectHelper = require('../../common/ObjectHelper.js');
var classNames = require('classnames');
var reactNumberFormat_es = require('../../node_modules/react-number-format/dist/react-number-format.es.js');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = {
  zillowDataText: {
    color: 'white',
    textShadow: '1px 1px black'
  },
  copyRightText: {
    fontSize: 6,
    paddingTop: 4
  },
  zillowDataView: {
    height: '100%'
  }
};

var renderZestimate = function renderZestimate(classes, zestimate) {
  return ObjectHelper.isPresent(zestimate) && React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    variant: "caption",
    className: classes.zillowDataText
  }, "Zestimate"), React__default["default"].createElement(reactNumberFormat_es, {
    className: classes.zillowDataText,
    value: zestimate,
    displayType: 'text',
    thousandSeparator: true,
    prefix: '$',
    renderText: function renderText(value) {
      return React__default["default"].createElement(Typography, {
        variant: "body2",
        className: classes.zillowDataText
      }, value);
    }
  }));
};

var renderYearBuilt = function renderYearBuilt(classes, yearBuilt) {
  return ObjectHelper.isPresent(yearBuilt) && React__default["default"].createElement(Grid, {
    item: true,
    style: {
      paddingTop: 4
    }
  }, React__default["default"].createElement(Typography, {
    variant: "caption",
    className: classes.zillowDataText
  }, "Built in ", yearBuilt));
};

var renderBedrooms = function renderBedrooms(classes, bedrooms) {
  return ObjectHelper.isPresent(bedrooms) && React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    variant: "body2",
    className: classes.zillowDataText
  }, bedrooms), React__default["default"].createElement(Typography, {
    variant: "caption",
    className: classes.zillowDataText
  }, "Beds"));
};

var renderBathrooms = function renderBathrooms(classes, bathrooms) {
  return ObjectHelper.isPresent(bathrooms) && React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    variant: "body2",
    className: classes.zillowDataText
  }, bathrooms), React__default["default"].createElement(Typography, {
    variant: "caption",
    className: classes.zillowDataText
  }, "Baths"));
};

var renderHouseSize = function renderHouseSize(classes, houseSize) {
  return ObjectHelper.isPresent(houseSize) && React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    variant: "body2",
    className: classes.zillowDataText
  }, houseSize), React__default["default"].createElement(Typography, {
    variant: "caption",
    className: classes.zillowDataText
  }, "Sq.ft."));
};

var renderCopyRight = function renderCopyRight(classes, zillowData) {
  return (ObjectHelper.isPresent(zillowData.bedrooms) || ObjectHelper.isPresent(zillowData.bathrooms) || ObjectHelper.isPresent(zillowData.house_size) || ObjectHelper.isPresent(zillowData.zestimate)) && React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    className: classNames__default["default"](classes.zillowDataText, classes.copyRightText)
  }, "\xA9 Zillow, Inc. 2006-2019"));
};

var ZillowDataView = function ZillowDataView(_ref) {
  var classes = _ref.classes,
      zillowData = _ref.zillowData;
  return ObjectHelper.isPresent(zillowData) && React__default["default"].createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "flex-start",
    className: classes.zillowDataView
  }, renderZestimate(classes, zillowData.zestimate), renderYearBuilt(classes, zillowData.year_built), React__default["default"].createElement(Grid, {
    item: true,
    xs: true,
    style: {
      paddingTop: 4
    }
  }, React__default["default"].createElement(Grid, {
    container: true,
    direction: "row",
    spacing: 16,
    justify: "flex-start"
  }, renderBedrooms(classes, zillowData.bedrooms), renderBathrooms(classes, zillowData.bathrooms), renderHouseSize(classes, zillowData.house_size))), renderCopyRight(classes, zillowData));
};

ZillowDataView.defaultProps = {
  zillowData: {}
};
var ZillowDataView$1 = withStyles(styles)(ZillowDataView);

module.exports = ZillowDataView$1;
